module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"code":"Code","name":"Name","feeGroup":"Fee Group","apr":"APR"},"et":{"code":"Code","name":"Name","feeGroup":"Fee Group","apr":"APR"},"ru":{"code":"Code","name":"Name","feeGroup":"Fee Group","apr":"APR"}}')
  delete Component.options._Ctor
}
